<template>
    <div class="user-import-upload">
        <div class="user-import-upload__loading" v-if="loading">{{trans('user-import.upload.loading')}}</div>
        <div class="user-import-upload__messages">
            <alert type="warning" v-if="jobsRunning">
                {{ trans('user-import.upload.jobs-running') }}
            </alert>
            <alert type="error" v-if="fileErrors.length">
                <div>
                    <p>{{trans('user-import.upload.file-looks-corrupt')}}</p>
                    <ul>
                        <li v-for="error in fileErrors" :key="error"> {{error}} </li>
                    </ul>
                </div>
            </alert>
            <alert type="success" v-if="success">
                {{trans('user-import.upload.files-looks-okay', {numberOfUsers: usersToBeImported.length})}}
            </alert>
        </div>
        <div class="user-import-upload__dropzone">
            <dropzone
                name="user-import-file"
                @change="handleExcelFileChange"
                accept=".xls,.xlsx,.csv"
            >{{trans('user-import.upload.dropzone-instruction')}}</dropzone>
        </div>
        <div class="user-import-upload__download">
            <a
                role="button"
                class="btn btn--tertiary"
                :href="route('tenant.user-import.template-download', client.id || 0)"
            >{{ trans('users.label.download_template') }}</a>
        </div>
    </div>
</template>

<script>
import { EventBus } from '../eventbus.js';

export default {
    props: {
        client: {
            type: Object,
            default: () => {
                return {};
            }
        },
        jobsRunning: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            loading: false,
            success: false,
            fileErrors: [],
            usersToBeImported: []
        };
    },
    watch: {
        usersToBeImported: function() {
            this.$emit('users-to-be-imported-changed', this.usersToBeImported)
        }
    },
    methods: {
        handleExcelFileChange(files) {
            const fileToUpload = files.length ? files[0] : null;

            this.success = false;
            this.usersToBeImported = [];
            this.fileErrors = [];

            if (fileToUpload) {
                this.uploadAndParse(fileToUpload);
            }
        },
        uploadAndParse(file) {
            this.loading = true;

            const formData = new FormData();
            formData.append('user-import-file', file);
            formData.append('client', this.client.id);

            axios
                .post(this.route('tenantapi.user-import.upload'), formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                })
                .then(({data}) => {
                    if(!data.usersToBeImported) {
                        throw new Error();
                    }
                    this.loading = false;
                    this.success = true;
                    this.usersToBeImported = data.usersToBeImported;

                })
                .catch(({response}) => {
                    this.loading = false;

                    // Show custom errors if they exists
                    if(response.data.errors) {
                        this.fileErrors = response.data.errors['user-import-file'];
                        return;
                    }

                    this.fileErrors = [this.trans('user-import.upload.unknown-error')];
                });
        }
    }
};
</script>
